import{styled as t}from"@mui/material/styles";const e=t("div")((({theme:t})=>({paddingLeft:t.spacing(12)})));export{e as Container};
//# sourceMappingURL=styles.js.map
